<template>
    <div @click="chatClick()" id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vue-headful :title="$t('chat')" />

        <!-- Сайтбар чата -->
        <ChatSidebar ref="ChatSidebar" />

        <!-- Область чата -->
        <ChatDialog :clickNotClose="clickNotClose" />

        <!-- Окно контактов -->
        <ContactPopup />

        <!-- Окно добавления пользователя в чат -->
        <AddMemberPopup />

        <!-- Попап с изображением -->
        <ImagePopup />
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ChatDialog from './ChatDialog'
import ChatSidebar from './ChatSidebar'
import ContactPopup from './ContactPopup'
import AddMemberPopup from './AddMemberPopup'
import ImagePopup from './ImagePopup'
import {mapState} from 'vuex'
import 'lazysizes'
let returned = false
export default {
    data () {
        return {
            active               : true,
            isHidden             : false,
            searchContact        : '',
            activeChatUser       : null,
            typedMessage         : '',
            isChatPinned         : false,
            settings             : {
                maxScrollbarLength : 60,
                wheelSpeed         : 0.70
            },
            clickNotClose        : true,
            isChatSidebarActive  : true
        }
    },
    beforeDestroy() {
        if(this.openDialog) {
            this.$store.commit('chat/SET_OPEN_DIALOG', null)
            this.$store.commit('chat/CLEAR_OPEN_DIALOG')
        }
    },
    computed: {
        ...mapState({
            contacts: state => state.chat.contacts,
            websocket: state => state.chat.websocket,
            chatMessage: state => state.chat.chatMessage,
            openDialog: state => state.chat.openDialog
        })
    },
    methods: {
        chatClick() {
            if(this.openDialog && this.openDialog.new_message_count > 0)
                this.$store.commit('chat/CHANGE_MESSAGE_COUNT')
        },
        toggleChatSidebar (value = false) {
            if (!value && this.clickNotClose) return
            this.isChatSidebarActive = value
        },
        async getCurrentChat() {
            const query = this.$route.query
            if(query && query.id) {
                try {
                    await this.$store.dispatch('chat/getCurrentChat', query.id)
                } catch(e) {
                    this.$router.push({name: 'chat'})
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                }
            }
            if(query && query.user) {
                try {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            scale: 0.6
                        })
                    })
                    let user = query.user
                    const res = await this.$store.dispatch('chat/getUserChat', query.user)
                    if(res) {
                        this.$router.push({name: 'chat', query: {id: res.id}})
                        this.$store.commit('chat/SET_OPEN_DIALOG', res)
                    }
                } catch(e) {
                    this.$router.push({name: 'chat'})
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                } finally {
                    this.$vs.loading.close()
                }
            }
        },
        async updateMessageList() {
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '.chat-content-scroll-area',
                        scale: 0.6
                    })
                })
                await this.$store.dispatch('chat/getMessage', true)
            } catch(e) {

            } finally {
                returned = true
                this.$vs.loading.close('.chat-content-scroll-area > .con-vs-loading')
            }
        },
        updateDialogList() {
            try {
                this.$refs.ChatSidebar.clearPage()
                this.$store.dispatch('chat/updateDialogs')
            } catch(e) {

            }
        }
    },
    components: {
        VuePerfectScrollbar,
        ChatSidebar,
        ChatDialog,
        ContactPopup,
        AddMemberPopup,
        ImagePopup
    },
    created () {
        this.getCurrentChat()
    },
    mounted () {
        if (/Mobi/.test(navigator.userAgent)) {
            if(!returned) {
                window.addEventListener('focus',  () => {
                    if(this.websocket.connect)
                        this.$webSocketsChatDisconnect()

                    this.$webSocketsChatConnect()

                    if(this.openDialog && this.chatMessage[this.openDialog.id])
                        this.updateMessageList()

                    this.updateDialogList()
                })
            }
        }
    }
}
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
@media only screen and (max-width: 893px) {
    .chat_cont_popup{
        .vs-popup--content{
            height: 100%;
        }
        .vs-popup{
            height: 95%;
        }
    }
}
</style>
